import React, { forwardRef, useContext, useState } from 'react'
import { StyleSheet, Text, TextInput, TextInputProps as RNTextInputProps, View, TextStyle } from 'react-native'
import { ThemeContext } from '../../context/ThemeContext'
import { textStyles } from '../../../style'

const LABEL_SPACE = 4

type TextInputProps = {
  value: string
  onChange: (value: string) => void
  label?: string
  placeholder?: string
  textInputProps?: RNTextInputProps
  required?: boolean
  errorText?: string
  disabled?: boolean
  focusColor?: string
  textStyle?: TextStyle
}

export const ThemedTextInput = forwardRef<TextInput, TextInputProps>((
  props: TextInputProps, ref
) => {
  const theme = useContext(ThemeContext)
  const { primary, borderColor, textMain, placeholder } = theme.theme.colors
  const [isFocused, setIsFocused] = useState(false)

  return (
    <View>
      {props.label && (
        <Text
          style={[
            textStyles.label,
            {
              color: isFocused ? props.focusColor || primary : props.textInputProps?.style?.color || textMain,
              marginHorizontal: props.textInputProps?.style?.marginHorizontal || 0,
              marginBottom: LABEL_SPACE,
            },
          ]}
        >
          {props.label}
          {props.required && <Text style={[textStyles.label, { color: 'red' }]}> *</Text>}
        </Text>
      )}
      <TextInput
        ref={ref}
        placeholder={props.placeholder}
        placeholderTextColor={placeholder}
        value={props.value}
        onChangeText={props.onChange}
        editable={!props.disabled}
        {...props.textInputProps}
        onFocus={(e) => setIsFocused(props.disabled ? false : true)}
        onBlur={() => setIsFocused(false)}
        style={[
          styles.input,
          textStyles.body,
          {
            color: textMain,
            borderColor: isFocused ? props.focusColor || primary : borderColor,
            height: props.textInputProps?.multiline ? undefined : 42,
          },
          props.textInputProps?.style,
        ]}
      />
      {props.errorText && <Text style={[textStyles.subscript, { color: 'red', marginTop: LABEL_SPACE }]}>{props.errorText}</Text>}
    </View>
  )
})

ThemedTextInput.displayName = "ThemedTextInput"

const styles = StyleSheet.create({
  input: {
    borderRadius: 10,
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderWidth: 1,
    outlineWidth: 0,
  },
})


